const demoPath = {
  tableComponents: '/demo/table-components',
  actionStack: '/demo/action-stack',
  cgButton: '/demo/cg-button'
};

export default demoPath;
